import { PropsWithChildren } from "react";
import { ChangeLogData } from "../domain/models/change_log_data";

/**
 * ModalContainer
 */

type Props = {
  changeLogData?: ChangeLogData | null,
};

export const ModalContainer = ({ children }: PropsWithChildren<Props>) => {
  return (
    <div className="w-full flex flex-col border-b border-[#e5e7eb50]">
      {children}
    </div>
  );
}